import { createSlice } from '@reduxjs/toolkit';

interface ValueProps {
  reservedProfileId: string[];
}
const censoredSlice = createSlice({
  name: 'reservedProfileId',
  initialState: {
    value: {
      reservedProfileId: [],
    } as ValueProps,
    loading: false,
    error: '',
  },
  reducers: {
    getReservedProfileId: (state) => {
      const assignState = state;
      assignState.loading = true;
    },
    setReservedProfileId: (state, action) => {
      const assignState = state;
      assignState.value = { ...assignState.value, reservedProfileId: action.payload };
      assignState.loading = false;
    },
    updateReservedProfileId: (state, _action) => {
      const assignState = state;
      assignState.loading = true;
      assignState.error = '';
    },
    updateReservedProfileIdSuccess: (state, _action) => {
      const assignState = state;
      assignState.loading = false;
      assignState.error = '';
    },
    fail: (state, _action) => {
      const assignState = state;
      assignState.loading = false;
    },
  },
});
export const {
  getReservedProfileId,
  setReservedProfileId,
  updateReservedProfileId,
  updateReservedProfileIdSuccess,
  fail,
} = censoredSlice.actions;

export default censoredSlice.reducer;
